import { get } from '@api/apiFetcher'
import b64toBlob from 'b64-to-blob'

const API = '/api/photos/b64_photos/'

const getPhotosFromPid = async (user, pid, setFiles, { onDefaultPreload }) =>
    get({ path: `${API}${pid}`, auth: user?.token })
        .then(res => {
            if (!res.b64) return
            setFiles(onDefaultPreload
                ? onDefaultPreload(toBlobs(res.b64))
                : toBlobs(res.b64))
        })

function toBlobs (b64Array) {
    return b64Array
        .map(({ type, data }) => b64toBlob(data, type))
}

export default getPhotosFromPid